import React from "react";
import { replaceQuotationMarksWithGuillemets } from "../../../util/format/guillemets";
var ContentText = function ContentText(_ref) {
    var text = _ref.text, index = _ref.index;
    var splittedByTags = text.replace(/(<[^>]+>)([^<]+)/g, "$1**&&**$2**&&**").split("**&&**");
    var replacedText = splittedByTags.map(function (t) {
        return replaceQuotationMarksWithGuillemets(t);
    }).join("");
    return /*#__PURE__*/ React.createElement("div", {
        key: index,
        className: "content-text",
        dangerouslySetInnerHTML: {
            __html: replacedText
        }
    });
};
export default ContentText;
